import { BRAND_LOGO_URL, NABH_LOGO_URL } from "@/brand";

/**
 * BrandLogo — the horizontal Badarinath Ayurveda Hospital logo.
 * Prop `size` controls the height class; width auto-fits (contain).
 *
 * variant="full"  — image only (default)
 * variant="wall"  — image + "NABH Entry-Level" badge below (for letterheads)
 */
export function BrandLogo({ size = "h-10", className = "" }) {
  return (
    <img
      src={BRAND_LOGO_URL}
      alt="Badarinath Ayurveda Hospital"
      className={`${size} w-auto object-contain ${className}`}
      data-testid="brand-logo"
    />
  );
}

/**
 * NabhBadge — accreditation indicator. Uses the official PNG when
 * available, otherwise falls back to a clean text pill.
 */
export function NabhBadge({ compact = false, className = "" }) {
  if (NABH_LOGO_URL) {
    return (
      <img
        src={NABH_LOGO_URL}
        alt="NABH Entry-Level Accredited"
        className={`h-10 w-auto object-contain ${className}`}
        data-testid="nabh-badge"
      />
    );
  }
  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full border-2 border-[#0A5F3D] bg-white ${
        compact ? "px-2 py-0.5" : "px-2.5 py-1"
      } ${className}`}
      data-testid="nabh-badge"
      title="Accredited: NABH Entry-Level standards for small healthcare organisations"
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full bg-[#0A5F3D]`}></span>
      <div className="leading-tight">
        <div className={`font-bold text-[#0A5F3D] ${compact ? "text-[9px]" : "text-[10px]"} tracking-[0.18em]`}>
          NABH · ENTRY-LEVEL
        </div>
        {!compact && (
          <div className="text-[8px] text-[#5C5652] tracking-wider uppercase">
            Accredited standards
          </div>
        )}
      </div>
    </div>
  );
}
